import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import NavBar from '../components/NavBar';
import Section from '../components/sections/Section';
import ViewSections from '../components/sections/ViewSections';
import { useParams } from 'react-router-dom';

const SectionsView = () => {
    const sectionId = useParams();
    return (
        <div>
            <Header />
            <NavBar />
            <Section sectionIdToEdit={sectionId}/>
            <ViewSections limit={6} />
            <Footer />
        </div>
    )
}

export default SectionsView
